module.exports = __webpack_public_path__ + "static/collection1-600ecede8f4c7a9322b6fc65ed6f8002.jpg";